function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Asset-Artboard-Page",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "CTA-Play-ICONS/48/PLAY"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-43-Copy-4"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  fill: "#7446FF",
  cx: 21,
  cy: 21,
  r: 21
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Triangle",
  fill: "#FFFFFF",
  transform: "translate(23.000000, 21.000000) rotate(90.000000) translate(-23.000000, -21.000000) ",
  points: "22.9999999 17.9999998 28 23.9999998 17.9999998 23.9999998"
}))));

var SvgPlay2X = function SvgPlay2X(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "42px",
    height: "42px",
    viewBox: "0 0 42 42",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPlay2X, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/play@2x.c9e0be72.svg";
export { ForwardRef as ReactComponent };